<template>
  <div class="register">
    <div>
      <pcLoginWarp :contentType="contentType">
        <div slot="inputs" :class="$store.state.isMobile ? 'h5Login' : ''">
          <div class="registerInput">
            <span>{{$store.state.isMobile ? '*' : '* 手机号'}}</span>
            <el-input v-model="register.phone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
          </div>
          <div class="registerInput">
            <span>{{$store.state.isMobile ? '*' : '* 验证码'}}</span>
            <el-input auto-complete="new-password" v-model="register.verCode" placeHolder="请输入验证码" type="number"></el-input>
            <div class="button1" @click="getCode">{{hasCode ? `已发送(${timeNow}s)` : '获取验证码'}}</div>
          </div>
          <div class="registerInput">
            <span>{{$store.state.isMobile ? '*' : '* 密码'}}</span>
            <el-input v-model="register.password" placeHolder="请输入密码" type="password" auto-complete="new-password"></el-input>
          </div>
          <div class="registerInput">
            <span>{{$store.state.isMobile ? '*' : '* 确认密码'}}</span>
            <el-input v-model="register.conPassword" placeHolder="请再次输入密码" type="password" auto-complete="new-password"></el-input>
          </div>
          <div class="registerInput">
            <span>{{$store.state.isMobile ? '*' : '* 昵称'}}</span>
            <el-input v-model="register.name" placeHolder="请输入昵称"></el-input>
          </div>
        </div>
        <div @click="toRegister" slot="button" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'">立即注册</div>
      </pcLoginWarp>
    </div>
  </div>
</template>

<script>
import pcLoginWarp from '../../components/ticket/pcLoginWarp.vue'

export default {
  data() {
    return {
      register: {
        phone: '',
        password: '',
        verCode: '',
        conPassword: '',
        name: ''
      },
      contentType: 3,
      hasCode: false,
      timeNow: 60,
      timeInterval: '',
    };
  },

  components: {pcLoginWarp},

  methods: {
    getCode() {
      // let num = 19814925020
      if (this.hasCode) return
      this.$ajax(`/api/message/send/verification-code?phoneNumber=${this.register.phone}`).then((res) => {
        this.hasCode = true
        this.timeGo()
      })
    },

    timeGo() {
      this.timeInterval = setInterval(() => {
        this.timeNow --
      }, 1000)
    },

    toHome() {
      this.loginIn()
      this.$router.push({path: '/ticket/home', query: this.$route.query})
    },

    toRegister() {
      if (this.register.password != this.register.conPassword) return this.$message.error('两次密码输入不一致！')
      !isNaN(Number(this.$route.query.museumCode)) ? this.register.fid = this.$route.query.museumCode : this.register.museumCode = this.$route.query.museumCode
      this.$ajax.post('/api/auth/jwt/registered', this.register).then((res) => {
        this.$message.success('注册成功，请登录')
        let query = this.$route.query
        query.loginType = 1
        this.$router.push({path: '/ticket/login', query})
      })
    }
  },

  created() {
  },

  computed: {
  
  },

  watch: {
    timeNow(val) {
      if (val == 0) {
        clearInterval(this.timeInterval)
        this.hasCode = false
      }
    }
  },
}
</script>

<style lang="scss">
.register{
  .registerInput{
    width: 3rem;
    margin:auto;
    position: relative;
    span{
      position: absolute;
      top: 0.2rem;
      left: 0.1rem;
      font-size: 0.1rem;
    }
    .button1{
      top: 0.18rem !important;
    }
  }
  .registerInput .el-input__inner{
    background-color: unset;
    border-bottom: 1px solid #e5e5e5;
    // margin: 0.03rem 0;
  }
  .buttonNormal{
    margin: auto;
    margin-top: 0.5rem;
  }
  .h5Login{
    .textButton{
      font-size: 0.4rem;
      width: 3rem;

    }
    .newRegister{
      float: right;
    }
    .registerInput{
      width: unset;
      height: 1.5rem;
      position: relative;
      span{
        position: absolute;
        top: 0.65rem;
        left: 0.1rem;
        font-size: 0.5rem;
      }
      .button1{
        top: 0.3rem !important;
        width: 2rem;
        height: 1.15rem;
        line-height: 1.15rem;
        right: 0.5rem;
        position: absolute;
        border-radius: 0.6rem;
        padding: 0 0.4rem;
        color: #fff;
        font-size: 0.35rem;
      }
    }
  }
}
</style>
<style type="text/css">
  .logoContent .el-input__inner{
    width: 3rem;
    margin: 0.1rem;
    padding: 0.05rem 0.6rem;
    padding-right: 1rem;
    /*background-color: #f6f6f6;*/
    height: 0.35rem;
    border: unset;
  }
  .inputCode .el-input__inner{
    /*width: 2rem;*/
    /*padding-right: ;*/
  }
</style>
